<section class="aspect-auto h-screen overflow-hidden">
    <section class="h-full flex flex-col">
        <app-contract-top-bar [view]="ContractTopBarView.VERSION" [selectedVersion]="selectedVersion"
            [currentVersion]="currentVersion" [supportMenuItems]="supportMenuItems" [infoMenuItems]="infoMenuItems">
        </app-contract-top-bar>
        <div class="flex-1 grid grid-cols-12 w-full overflow-hidden">
            <div class="col-span-9 h-full overflow-hidden">
                <div class="h-full">
                    @if(contract){
                    <app-only-office-doc-editor [contractId]="contract._id" [user]="currentUser!" [configData]="config">
                    </app-only-office-doc-editor>
                    }
                </div>
            </div>
            <div class="col-span-3 bg-white h-full border border-l-2">
                <div class="flex flex-col h-full ">
                    <div class="flex align-items-center justify-between pl-4 pr-2 pt-6 flex-shrink-0">
                        <h3 class="font-medium">Version History</h3>
                        <hr>
                        <div class="flex gap-2 align-items-center">
                        </div>
                    </div>
                    <div class="max-w-full pt-8 p-4">
                        <div>
                            <div class="flex items-center justify-between text-black text-sm mb-2">
                                @if(currentVersion){
                                <span>{{currentVersion.createdAt | date: 'mediumDate'}} at {{
                                    currentVersion.createdAt | date: 'shortTime' }}</span>
                                }
                                <span>Current Version</span>
                            </div>
                            @if(versionLoading){
                            <div class="space-y-2 animate-pulse">
                                <div class="flex justify-between items-center bg-gray-200 p-2 rounded-base mb-2">
                                    <div class="flex gap-2">
                                        <div class="flex flex-col">
                                            <div class="flex flex-col">
                                                <div class="h-4 bg-gray-400 w-24 rounded"></div>
                                                <div class="h-3 bg-gray-400 w-40 rounded mt-1"></div>
                                            </div>
                                            <div class="flex gap-2">
                                                <div class="w-6 h-6 rounded-full bg-gray-400"></div>
                                                <div class="h-4 bg-gray-400 w-32 rounded mt-1"></div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="w-3 h-3 bg-gray-500 rounded-full mr-2"></div>
                                </div>
                            </div>
                            }
                            @else {
                            @if (!versions || versions.length ==0) {
                            <div class="flex justify-center items-center h-full">
                                <span class="text-gray-400">No versions available</span>
                            </div>
                            }
                            @else {
                            <!-- Current version card -->
                            <div class="flex justify-between items-center bg-orange-200 p-2 rounded-base mb-2 cursor-pointer"
                                (click)="showVersion(currentVersion)">
                                <div class="flex flex-col gap-1 min-w-0">
                                    <div class="flex items-center gap-1" (click)="$event.stopPropagation()">
                                        @if(editingVersion === currentVersion) {
                                        <input type="text" [(ngModel)]="tempVersionName"
                                            class="border rounded px-2 py-1 text-sm flex-1 min-w-0"
                                            (keyup.enter)="saveVersionName(currentVersion, $event)"
                                            (keyup.escape)="cancelEditing($event)">
                                        <app-button variant="ghost" severity="contrast" size="sm" icon="pi pi-check"
                                            iconSource="primeng" (clicked)="saveVersionName(currentVersion, $event)">
                                        </app-button>
                                        <app-button variant="ghost" severity="danger" size="sm" icon="pi pi-times"
                                            iconSource="primeng" (clicked)="cancelEditing($event)">
                                        </app-button>
                                        } @else {
                                        <span class="text-sm font-medium truncate cursor-text"
                                            (click)="startEditing(currentVersion, $event)">
                                            {{currentVersion.name}}
                                        </span>
                                        <app-button variant="ghost" severity="contrast" size="sm" icon="pi pi-pencil"
                                            iconSource="primeng" (clicked)="startEditing(currentVersion, $event)">
                                        </app-button>
                                        }
                                    </div>
                                    <span class="text-xs text-gray-700">
                                        {{ currentVersion.createdAt | date: 'mediumDate' }} at
                                        {{ currentVersion.createdAt | date: 'shortTime' }}
                                    </span>
                                    <app-user-name-display [user]="currentVersion.createdBy" [variant]="'avatar-name'">
                                    </app-user-name-display>
                                </div>
                                <span class="w-3 h-3 bg-orange-500 rounded-full flex-shrink-0 ml-2"></span>
                            </div>
                            <hr>
                            <!-- Previous versions list -->
                            <div class="max-h-[calc(100vh-17rem)] overflow-y-auto">
                                @for (item of filteredVersions; track item._id) {
                                <div class="mt-2">
                                    <div (click)="showVersion(item)"
                                        class="flex justify-between items-center p-2 rounded-base mb-2 cursor-pointer text-black border transition-colors ease-in-out"
                                        [ngClass]="selectedVersion && selectedVersion._id === item._id ? 'bg-white border-orange' : 'bg-gray-100 border-transparent hover:bg-white hover:border-gray-200'">
                                        <div class="flex flex-col gap-1 min-w-0 flex-1">
                                            <div class="flex items-center gap-1" (click)="$event.stopPropagation()">
                                                @if(editingVersion === item) {
                                                <input type="text" [(ngModel)]="tempVersionName"
                                                    class="border rounded px-2 py-1 text-sm flex-1 min-w-0"
                                                    (keyup.enter)="saveVersionName(item, $event)"
                                                    (keyup.escape)="cancelEditing($event)">
                                                <app-button variant="ghost" severity="contrast" size="sm"
                                                    icon="pi pi-check" iconSource="primeng"
                                                    (clicked)="saveVersionName(item, $event)">
                                                </app-button>
                                                <app-button variant="ghost" severity="danger" size="sm"
                                                    icon="pi pi-times" iconSource="primeng"
                                                    (clicked)="cancelEditing($event)">
                                                </app-button>
                                                } @else {
                                                <span class="text-sm font-medium truncate cursor-text"
                                                    (click)="startEditing(item, $event)">
                                                    {{item.name}}
                                                </span>
                                                <app-button variant="ghost" severity="contrast" size="sm"
                                                    icon="pi pi-pencil" iconSource="primeng"
                                                    (clicked)="startEditing(item, $event)">
                                                </app-button>
                                                }
                                            </div>
                                            <span class="text-xs text-gray-600">
                                                {{ item.createdAt | date: 'mediumDate' }} at
                                                {{ item.createdAt | date: 'shortTime' }}
                                            </span>
                                            <app-user-name-display [user]="item.createdBy" [variant]="'avatar-name'">
                                            </app-user-name-display>
                                        </div>
                                        <div (click)="$event.stopPropagation()" class="flex-shrink-0 ml-1">
                                            <app-menu #versionMenu [items]="getMenuItems(item)">
                                                <app-button (clicked)="versionMenu.toggle($event)" variant="ghost"
                                                    severity="contrast" size="sm" icon="pi pi-ellipsis-v"
                                                    iconSource="primeng">
                                                </app-button>
                                            </app-menu>
                                        </div>
                                    </div>
                                </div>
                                }
                            </div>
                            }
                            }
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</section>

<app-capture-issue #captureIssue></app-capture-issue>

<p-dialog header="Raise a Support Ticket" [(visible)]="supportTicketDialog" [modal]="true" [closable]="true"
    [draggable]="false" [resizable]="false" class="support-ticket-dialog"
    [style]="{width: '40rem', height: '72rem', maxWidth: '90vw', maxHeight: '90vh', zIndex: '10001'}"
    [baseZIndex]="10001" appendTo="body" (onHide)="onSupportTicketDialogHide()">
    <app-support-ticket-form #supportTicketForm [isDialog]="true" (ticketSubmitted)="onSupportTicketSubmitted()">
    </app-support-ticket-form>
</p-dialog>